export const innerPaddingDesktop = 24;
export const innerPaddingMobile = 16;
